import { featuredCategories } from "@/mocks/categories";

export default function CategoryGrid() {
  return (
    <section id="categories" className="w-full px-4 md:px-8 py-16 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-extrabold text-foreground-950">
            Explore Popular Categories
          </h2>
          <p className="mt-3 text-base text-foreground-600 max-w-lg mx-auto">
            Browse our carefully organized AllChinaBuy Spreadsheet categories with products from verified sellers
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4 md:gap-6">
          {featuredCategories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative aspect-square rounded-lg overflow-hidden cursor-pointer"
              data-product-shop
            >
              <img
                src={cat.image}
                alt={`${cat.name} category on AllChinaBuy Spreadsheet`}
                title={`${cat.name} - AllChinaBuy Spreadsheet`}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/65 via-black/15 to-transparent" />
              <div className="absolute inset-0 flex flex-col items-center justify-end pb-5 px-3">
                <span className="text-base md:text-lg font-extrabold text-background-50 tracking-tight">
                  {cat.name}
                </span>
                <span className="text-xs text-background-50/80 mt-1 font-medium">
                  {cat.desc}
                </span>
                <span className="text-[10px] text-background-50/60 mt-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  View Collection →
                </span>
              </div>
            </a>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 text-sm font-semibold rounded-md hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
          >
            Browse All 14 Categories
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </a>
        </div>
      </div>
    </section>
  );
}